import { Base } from '../core/base.model';

export class DenunciaComentario extends Base {
  id_comentario: number;
  id_denuncia:   number;
  comentario:    string;
  fecha:         Date;
  id_usuario:    number;
  nombreUsuario: string;
}
